import {
	TIMESPAN_OHLC_OPTIONS,
	TIMESPAN_PORTFOLIO_OPTIONS,
	TIMESPAN_PORTFOLIO_FILTERED_OPTIONS,
	TIMEPERIOD_OHLC_OPTIONS
} from "@helpers/const/timespan";

// without 6m and 5y - used only for FF fallback
export const portfolioTimeFilter = TIMESPAN_PORTFOLIO_FILTERED_OPTIONS;

// adds 6m and 5y - this filter uses slightly different values than e.g. OHLC api ("six_month" and "max")
export const portfolioNewTimeFilter = TIMESPAN_PORTFOLIO_OPTIONS;

export const assetDetailPageNewTimeFilter = TIMESPAN_OHLC_OPTIONS;

export const marginPositionDetailTimeFPeriod = TIMEPERIOD_OHLC_OPTIONS;

export const PORTFOLIO_ALLOCATION_MIN_DISPLAY_PERCENTAGE = 1;

export const PortfolioAssetGroup = {
	Crypto: "crypto",
	LeveragedToken: "leveraged_token",
	Index: "index",
	Stock: "stock",
	Etf: "etf",
	Etc: "etc",
	Metal: "metal",
	Fiat: "fiat",
	SecurityTokens: "security_token"
};

export const colorClassMapping = {
	[PortfolioAssetGroup.Crypto]: "var(--color-class-crypto)",
	[PortfolioAssetGroup.LeveragedToken]: "var(--color-class-leverage)",
	[PortfolioAssetGroup.Index]: "var(--color-class-index)",
	[PortfolioAssetGroup.Stock]: "var(--color-class-stock)",
	[PortfolioAssetGroup.Etf]: "var(--color-class-etf)",
	[PortfolioAssetGroup.Etc]: "var(--color-class-etc)",
	[PortfolioAssetGroup.Metal]: "var(--color-class-metal)",
	[PortfolioAssetGroup.Fiat]: "var(--color-class-fiat)",
	[PortfolioAssetGroup.SecurityTokens]: "var(--color-class-security-tokens)",
	default: "#B0B0B0"
};

export const fontColorClassMapping = {
	[PortfolioAssetGroup.Crypto]: "var(--color-neutrals-on-fill-light)",
	[PortfolioAssetGroup.LeveragedToken]: "var(--color-neutrals-on-fill-dark)",
	[PortfolioAssetGroup.Index]: "var(--color-neutrals-on-fill-light)",
	[PortfolioAssetGroup.Stock]: "var(--color-neutrals-on-fill-light)",
	[PortfolioAssetGroup.Etf]: "var(--color-neutrals-on-fill-dark)",
	[PortfolioAssetGroup.Etc]: "var(--color-neutrals-on-fill-light)",
	[PortfolioAssetGroup.Metal]: "var(--color-neutrals-on-fill-dark)",
	[PortfolioAssetGroup.Fiat]: "var(--color-text-button-primary-inverted)"
};

export const othersImageMappingLightMode = {
	[PortfolioAssetGroup.Crypto]: "/assets/images/global/assets-white.svg",
	[PortfolioAssetGroup.LeveragedToken]: "/assets/images/global/assets-white.svg",
	[PortfolioAssetGroup.Index]: "/assets/images/global/assets-white.svg",
	[PortfolioAssetGroup.Stock]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.Etf]: "/assets/images/global/assets-white.svg",
	[PortfolioAssetGroup.Etc]: "/assets/images/global/assets-white.svg",
	[PortfolioAssetGroup.Metal]: "/assets/images/global/assets-white.svg",
	[PortfolioAssetGroup.Fiat]: "" // doesn't exist for fiat
};

// TODO: unused, but should be used in the future
export const othersImageMappingDarkMode = {
	[PortfolioAssetGroup.Crypto]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.LeveragedToken]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.Index]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.Stock]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.Etf]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.Etc]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.Metal]: "/assets/images/global/assets-black.svg",
	[PortfolioAssetGroup.Fiat]: "" // doesn't exist for fiat
};
